import { DataConnectorTypesEnum } from '../enums/data-connector-types.enum';
import { GoogleAnalyticsEntityApiModel } from './google-analytics-entity-api.model';

export class GoogleAnalyticsEntityModel {
    id: string;
    name: string;
    displayName: string;
    dataConnectorType: DataConnectorTypesEnum;
    timeZone?: string;

    constructor(apiModel?: GoogleAnalyticsEntityApiModel) {
        if (apiModel) {
            this.id = apiModel.id;
            this.name = apiModel.name;

            // if this entity is of type 'property', we want to show both id and name concatenated when it appears in the autocomplete
            this.displayName = `${apiModel.name} (${apiModel.id})`;
            this.timeZone = apiModel.timeZone;
        }
    }
}
